import axios from "axios";

const axiosInstance = axios.create({
    baseURL: 'https://expense-tracker-sr.herokuapp.com',
});

export default axiosInstance;